'use client'

import { useQueryResults } from "@/hooks/useQueryResults";
import { useMemo } from "react";
import { ChartDataPoint, ChartSeries, LineChart } from "./charts/line-chart";

export function YieldChart() {
    const { results } = useQueryResults({id: 6711808})

    const formattedData = useMemo((): ChartSeries[] => {
        if (!results || results.length === 0) return [];

        let keys = Object.keys(results[0]).filter((k: string) => !['day', 'month', 'date', 'date_unix'].includes(k))
        let days = [...new Set(results.map(r => r.date!))]

        let dataObj: Record<string, ChartDataPoint[]> = {}
        for (let key of keys) {
            dataObj[key] = []
        }

        for (let day of days) {
            const dps = results.filter(r => day.isSame(r.day)).at(0)
            if(!dps) continue;
            for (let key of keys) {
                dataObj[key].push({
                    x: day.toDate(),
                    y: dps[key] as number || null
                })
            }
        }

        let out: ChartSeries[] = []

        for (let key of keys) {
            out.push({
                id: key,
                data: dataObj[key]
            })
        }

        return out
    }, [results])

    return <div className="h-[40vh]">
        <LineChart
            data={formattedData}
            title="Yield over time"
            description="Major mainnet venues for stable coin yield"
            yAxisFormatter={(d: number | null) => d!==null?`${(d * 100).toFixed(2)}%`:'No data'}
            tooltip={{
                seriesValueFormatter(v) {
                    return `${(v * 100).toFixed(2)}%`
                }
            }}
        />
    </div>
}